var $e4b9aef18b0db8dc$exports = {};
$e4b9aef18b0db8dc$exports = {
    "close": `Sulje`,
    "notifications": `Ilmoitukset`
};


export {$e4b9aef18b0db8dc$exports as default};
//# sourceMappingURL=fi-FI.module.js.map
